import { useState } from 'react';
import MojitoPresentation from 'mojito/presentation';

const { CardBackgroundImage, SportWatermarkImage, SportWatermarkImageTypes } =
    MojitoPresentation.Components;

// Artwork that fails to load falls back to the watermark, so a broken promotion image does not
// leave the card blank behind its content.
const CardBackground = props => {
    const {
        mojitoTools,
        sportId,
        imgUrl,
        position = SportWatermarkImageTypes.POSITIONS.TOP_RIGHT,
    } = props;
    const { config } = mojitoTools;
    const [failedImgUrl, setFailedImgUrl] = useState();

    if (imgUrl && imgUrl !== failedImgUrl) {
        return (
            <CardBackgroundImage
                src={imgUrl}
                config={config.cardBackgroundImage}
                onError={() => setFailedImgUrl(imgUrl)}
            />
        );
    }

    return (
        <SportWatermarkImage sportId={sportId} position={position} config={config.sportWatermark} />
    );
};

export default CardBackground;
